import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";


export const StyledSectionFindUs = styled(Styled.Section)`
overflow:hidden;
`
export const StyledImageWrapper = styled.div`
position: relative;
z-index:2;
margin-top:24px;
&:after {
    position: absolute;
    bottom: -20%;
    right: -15%;
    display: block;
    content: "";
    width: 303px;
    height: 303px;
    border-radius: 50%;
    background: ${EColors.accent_300};
    opacity: 0.2;
    filter: blur(100px);
    z-index: -1;
  }

  @media screen and (max-width: 767px) {
    margin-top:48px;
    &:after {
      position: absolute;
      bottom: -15%;
      right: -45%;;
      display: block;
      content: "";
      width: 303px;
      height: 303px;
      border-radius: 50%;
      background: ${EColors.accent_300};
      opacity: 0.2;
      filter: blur(100px);
      z-index: -1;
    }
  }
`
export const ImageMap = styled.img`
width:100%;
height:100%;
`


